export function OutlineMallIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.56348 7.30359C8.56348 5.48027 9.87927 4 11.5005 4C13.1218 4 14.4376 5.48027 14.4376 7.30359"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1218 20.0303H4.87923C3.72791 20.0303 2.84444 19.0012 3.02301 17.864L4.4046 8.89774C4.54558 7.98138 5.33506 7.30469 6.26082 7.30469H16.7402C17.666 7.30469 18.4554 7.98138 18.5964 8.89774L19.978 17.864C20.1519 19.0012 19.2731 20.0303 18.1218 20.0303Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
